import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const locationArrow: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="m10.953-9.281-5 10.015A.48.48 0 0 1 5.5 1c-.023 0-.059-.008-.11-.016a.45.45 0 0 1-.28-.171A.5.5 0 0 1 5 .5V-4H.5a.5.5 0 0 1-.312-.11.52.52 0 0 1-.172-.28.46.46 0 0 1 .03-.329.52.52 0 0 1 .235-.234l10-5A.5.5 0 0 1 10.5-10q.218 0 .36.14.105.113.14.282a.44.44 0 0 1-.047.297m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0.002 10)"
    />
  ),
  svgProps: {
    height: "11",
    width: "11.01",
  }
};
